import { render, staticRenderFns } from "./WeatherWidget.vue?vue&type=template&id=137ba876&scoped=true"
import script from "./WeatherWidget.vue?vue&type=script&lang=js"
export * from "./WeatherWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137ba876",
  null
  
)

export default component.exports